/**
 * Locale resolution for legal documents (ESCLOUD-181).
 *
 * There is no i18n layer in the client yet, so the browser locale is the best
 * available signal. English is the guaranteed fallback: the legal build fails
 * when a document has no `en` source.
 */
export function resolveLocale(availableLocales: string[]): string {
    const primary = (navigator.language || 'en').toLowerCase().split('-')[0];
    return availableLocales.includes(primary) ? primary : 'en';
}
